<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#2D9CDB"/>
    <path d="M6.17021 11.6685L4.756 10.2543C6.26763 7.48771 7.45521 6.2352 10.4129 4.59742L11.8271 6.01164C8.9516 7.62515 7.74796 8.92685 6.17021 11.6685ZM16.7839 15.2111L11.12 9.54717L9.70575 10.9614L15.3697 16.6253L13.2484 18.7466L18.8981 18.7396L18.9052 13.0898L16.7839 15.2111Z" fill="#F2F2F2"/>
  </svg>
</template>

<script>
export default {
  name: "NivelOrdinario"
}
</script>

<style scoped>

</style>
